// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { ApiNftLinkData } from '../models/ApiNftLinkData';
import { HttpFile } from '../http/http';

export class ApiNftLinkResponse {
    'is_enrichable': boolean;
    'validation_error': string | null;
    'data': ApiNftLinkData | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "is_enrichable",
            "baseName": "is_enrichable",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "validation_error",
            "baseName": "validation_error",
            "type": "string",
            "format": ""
        },
        {
            "name": "data",
            "baseName": "data",
            "type": "ApiNftLinkData",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiNftLinkResponse.attributeTypeMap;
    }

    public constructor() {
    }
}
